import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index';

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';

import VueCookies from 'vue-cookies';

// import Vue3VideoPlayer from '@cloudgeek/vue3-video-player'
// import '@cloudgeek/vue3-video-player/dist/vue3-video-player.css'
import Vue3VideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'

import "vue-draggable-list/dist/style.css";

import { OhVueIcon } from "oh-vue-icons";
import DashboardLayout from './layouts/Dashboard.vue';
import WindowsShow from './layouts/WindowShow.vue';
import DashboardSystem from './layouts/Dashboard_System.vue';
// import './plugins/click-away';
import './scss/app.scss';

const app = createApp(App);
app.use(Antd);
app.use(router);
app.use(VueCookies);
app.use(Vue3VideoPlayer)
// Adding template layouts to the vue components.
app.component("layout-default", DashboardLayout);
app.component("layout-windows", WindowsShow);
app.component("layout-system", DashboardSystem);
app.component("v-icon", OhVueIcon);
app.mount('#app');
